import React from "react";
import CommonNavbar from "../../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../../components/CommonFooter/CommonFooter";
import TermAndConditions from "../../components/Policy/TermAndConditions";

const TermAndConditionPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <TermAndConditions />
      <CommonFooter />
    </div>
  );
};

export default TermAndConditionPage;
